import styled from 'styled-components';

export const WidgetAutomatedEventFlyerForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
`;
